import { render, staticRenderFns } from "./edit360EvaluationQuestions.vue?vue&type=template&id=09964a15&scoped=true"
import script from "./edit360EvaluationQuestions.vue?vue&type=script&lang=js"
export * from "./edit360EvaluationQuestions.vue?vue&type=script&lang=js"
import style0 from "./edit360EvaluationQuestions.vue?vue&type=style&index=0&id=09964a15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09964a15",
  null
  
)

export default component.exports